/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-unresolved
import geoClient from '../../../../node_modules/@sgorg/geo-client/dist/index';

/**
 *  class for interfacing with and storing environment data
 */
export class OMT_EnvData {
  /**
   * constructor
   */
  constructor() {
    this._gbUserProfileData = null;
    this._entryPoint = null;
    this._entryPointData = null;
    this._payload = null;
    this._settings = null;
    this._isRestoreProgressPayload = false;
  }

  /**
   * set the user profile data
   * @param {Object} gbUserProfileData
   */
  setGBUserProfileData(gbUserProfileData) {
    this._gbUserProfileData = gbUserProfileData;
  }

  /**
   * get the game-backend user id
   * @returns {string}
   */
  get gbUserId() {
    if (!this._gbUserProfileData) return null;
    return this._gbUserProfileData.id;
  }

  /**
   * get the game-backend user handle
   * @returns {string}
   */
  get gbUserHandle() {
    if (!this._gbUserProfileData) return null;
    return this._gbUserProfileData.handle;
  }

  /**
   * define the settings / environment vars
   */
  defineSettings() {
    const locale = G.lang;
    console.log("locale", locale);
    const lang = locale.indexOf('_') > 0 ? locale.split('_')[0] : locale;
    console.log("lang", lang);

    this._settings = {
      env: {
        platform: '',//FBInstant.getPlatform(),
        country: '',
        tier: 1,
        locale,
        lang,
      },
      user: {
        userId: '',//FBInstant.player.getID(),
        name: '',//FBInstant.player.getName(),
        avatar: null,//FBInstant.player.getPhoto(),
        locale,
      },
      game: {
        id: G.BuildEnvironment.APP_ID,
        slug: G.BuildEnvironment.slug,
        isCookOMT: G.BuildEnvironment.isCookOMT,
      },
    };
    this._defineCountryAndTier();
  }

  /**
   * load country and catalog data and set the users country / IAP tier
   */
  _defineCountryAndTier() {
    /*Promise.all([geoClient.getCountry(), OMT.payments.getCatalogAsync()]).then((values) => {
      if (typeof values[0] === 'object') {
        this._settings.env.country = values[0].country;
        this._settings.env.tier = G.json['configs/countries'][this._settings.env.country].tier;
      } else if (typeof values[1][0].priceCurrencyCode === 'string') {
        const currency = values[1][0].priceCurrencyCode;
        this._settings.env.tier = G.json['configs/currency'][currency].tier;
      }
    }).catch((error) => {
      console.error('Error: could not get geolocation data.');
    });*/
  }

  /**
   * get a refernce to the settings / environment vars
   * @returns {Object}
   */
  get settings() {
    return this._settings;
  }

  /**
   * define entry point data
   */
  async defineEntryPoint() {
    this._entryPoint = null;//await FBInstant.getEntryPointAsync();
    this._entryPointData = null;//FBInstant.getEntryPointData();
  }

  /**
   * get the entryPoint name
   * @returns {string}
   */
  get entryPoint() {
    return this._entryPoint;
  }

  /**
   * get the entryPoint data
   * @returns {Object}
   */
  get entryPointData() {
    return this._entryPointData;
  }

  /**
   * define the payload data
   */
  definePayload() {
    if (this._entryPointData) {
      // Bot messages payload data is in the gamePayload property
      if (this._entryPointData.gamePayload) {
        this._payload = this._entryPointData.gamePayload;
        this._isRestoreProgressPayload = this._payload.additions && this._payload.additions.restoreProgression;
      } else {
        this._payload = this._entryPointData;
      }
    }
  }

  /**
   * reject / clear the current payload
   */
  rejectPayload() {
    this._payload = null;
  }

  /**
   * get the payload data
   * @returns {Object}
   */
  get payload() {
    return this._payload;
  }

  /**
   * check if we have a restore progress payload
   * @returns {boolean}
   */
  get isRestoreProgressPayload() {
    return this._isRestoreProgressPayload;
  }

  /**
   * get the platform
   * @returns {string}
   */
  get platform() {
    return this._settings.env.platform;
  }
}
